// extracted by mini-css-extract-plugin
export default {"button":"ArrowButton_button__zaVtt","disabled":"ArrowButton_disabled__gsCBd","icon":"ArrowButton_icon__CEC5-"};